import {workplaceTypes} from "../types";
import {ModalWindowContainerTotalAccCard} from "../Modal/ModalWindowContainerTotalAccCard";
import {ModalContainerWarningAccountingСards} from "../Modal/ModalContainerWarningAccountingCards"
import {ModalContainerTAC} from "../Modal/ModalContainerSignTotalAccCard";
import { HeaderMenuBlock } from '../Block/HeaderMenuBlock/HeaderMenuBlock'
import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import {isCanvasBlank} from "../functions";
import { VehicleNumberBlock } from "../Block/VehicleNumberBlock";
import SignaturePad from "signature_pad";
import {appNotification} from '@/components/AppNotification.js'
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';
import { flightMenuBlock } from '@/Block/FlightMenuBlock.js';

export var FinalAccountingCardPage = {
    controller: function () {
        var self = this;

        this.countChange = 0;
        this.newValue = new Map();

        if (!user.exists()) {
            m.route('/login');
            return;
        }

        interval.clearAll();

        loader.show();

        if (user.get('state.workplace') === workplaceTypes.driver) {
            this.topMenu = [
                { title: 'Задачи', url: '/vehicle/tasks', icon: 'fa-tasks' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];

            if (user.get('state.vehicleFreeTasksAvailable')) {
                this.topMenu.unshift(
                    { title: 'Свободные', url: '/vehicle/tasks/free', icon: 'fa-car' }
                )
            }
        } else if (user.get('state.workplace') === workplaceTypes.agent) {
            this.topMenu = [
                { title: 'Задачи', url: '/agent/tasks', icon: 'fa-tasks' },
                { title: 'Рейсы', url: '/agent/flights', icon: 'fa-plane' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];
        } else {
            this.topMenu = [
                { title: 'Задачи', url: '/', icon: 'fa-tasks' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o'},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];
        }

        this.data = m.request({
            method: 'GET',
            url: '/api/task/' + m.route.param('taskId') + '/accouting'
        }).then(function (response) {
            server.setOnline();
            loader.hide();
            storage.config = response.config;

            let temp = {};
            let arr = response.accountingCard;
            for(let i = 0; i < arr.length; i++) {
                temp[arr[i]["ID"].toString()] = arr[i]["ServiceValue"];
            }
            localStorage.setItem("accountingCard", JSON.stringify(temp));

            appNotification.list = response.notifications;

            server.initPing();
            appNotification.init();

            return response;
        }, function (response) {
            if (response && response.message) {
                self.errmsg = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });

    },
    view: function (ctrl) {
        return [
            m.component(HeaderMenuBlock, {
                time: ctrl.data().time,
                menu: ctrl.topMenu
            }),
            m("div[style='margin-top:0px']", [
                VehicleNumberBlock(),
                m.component(flightMenuBlock, {
                    board: ctrl.data().board,
                    menu: ctrl.data().menu,
                    tasks: ctrl.data().tasks,
                    currentTask: ctrl.data().currentTask,
                    tab: 'works'
                })
            ]),
            m(".container[style='padding-top:10px']", [
                m("p.text-center", "ФОРМИРОВАНИЕ ИТОГОВОЙ КАРТЫ УЧЕТА"),
                m("table.table", [
                    m("tr", [
                        m("td.col-xs-10[style='padding:0 10px']", [
                            m("p.text-center", "Услуга")
                        ]),
                        m("td.col-xs-2[style='padding:0 10px']", [
                            m("p.text-left", "Значение")
                        ])
                    ]),
                    ctrl.data().accountingCard.map(function(elem) {
                        let background = elem.PV == 'В' ? "bg-info" : "bg-danger";
                        return m("tr", [
                            m("td.col-xs-10[style='padding:0 6px 0 10px']", [
                                m("p.text-left."+background+"[style='font-weight: normal !important;']", elem.ServiceName)
                            ]),
                            m("td.col-xs-1[style='padding:0 6px 0 6px']", [
                                m("input.form-control[type='number'][style='height: 34px; overflow:hidden;'][rows='1'][id='input-"+elem.ID+"']", {
                                    value: ((parseFloat(elem.ServiceValue) - Math.trunc(elem.ServiceValue)) == 0.0 ? Math.trunc(elem.ServiceValue) : elem.ServiceValue),
                                    onchange: function (value) {
                                        let oldValue = JSON.parse(localStorage.getItem("accountingCard"));
                                        let defaultValue = (parseFloat(oldValue[elem.ID]) - Math.trunc(oldValue[elem.ID])) == 0.0 ?
                                            Math.trunc(oldValue[elem.ID]) : oldValue[elem.ID];
                                        if(defaultValue != value.currentTarget.value) {
                                            value.currentTarget.style.backgroundColor = "#dff0d8";

                                            ctrl.newValue.set(elem.ID, value.currentTarget.value);
                                            elem.ServiceValue = value.currentTarget.value;

                                            ctrl.countChange++;
                                        }
                                        else {
                                            value.currentTarget.style.backgroundColor = "#fff";
                                            if(ctrl.newValue.has(elem.ID)) {
                                                ctrl.newValue.delete(elem.ID);
                                                elem.ServiceValue = value.currentTarget.value;
                                            }
                                            ctrl.countChange--;
                                        }

                                        if(ctrl.countChange == 0)
                                            document.getElementById("saveChange").disabled = "disabled";
                                        else
                                            document.getElementById("saveChange").disabled = "";

                                        m.redraw.strategy("none");
                                    }
                                } )
                            ]),
                            m("td.col-xs-1[style='padding:10px 10px 0 6px']", [
                                elem.MessName
                            ])
                        ])
                    })
                ]),

                m(".row", [
                    m(".col-xs-8[colspan='8'][style='text-align: right']", ["Отправить изменения по значениям услуг"]),
                    m(".col-xs-4[colspan='4'][style='text-align: right; padding:2px 7px;'][id='tdResetAll']", [
                        m("button.btn.btn-info.btn-lg[style='width:100%'][id='saveChange']", {
                            disabled: ctrl.countChange == 0 ? "disabled" : "",
                            onclick: function () {
                                let query = "<Records>";
                                for (let pair of ctrl.newValue.entries()) {
                                    query += "<Record ID=\""+ pair[0] +"\" Value=\""+ pair[1] +"\"/>";
                                }
                                query += "</Records>";

                                loader.show();
                                m.request({
                                    method: 'PUT',
                                    url: '/api/task/' + m.route.param('taskId') + '/saveValueService',
                                    background: true,
                                    data: {xml: query}
                                }).then(function (response) {

                                    let temp = {};
                                    let arr = response.accountingCard;
                                    for(let i = 0; i < arr.length; i++) {
                                        temp[arr[i]["ID"].toString()] = arr[i]["ServiceValue"];
                                        document.getElementById("input-"+arr[i]['ID'].toString()).style.backgroundColor = "#fff";
                                    }
                                    localStorage.setItem("accountingCard", JSON.stringify(temp));
                                    ctrl.data().accountingCard = response.accountingCard;

                                    document.getElementById("saveChange").disabled = "disabled";
                                    m.redraw.strategy("none");

                                    loader.hide();
                                });
                            }
                        },"Сохранить")
                    ]),
                ]),
                m(".row", [
                    m(".col-xs-8[colspan='8'][style='text-align: right']", ["Посмотреть итоговую карту учета"]),
                    m(".col-xs-4[colspan='4'][style='text-align: right; padding:2px 7px;'][id='']", [
                        m("button.btn.btn-info.btn-lg[style='width:100%'][id='preview']", {
                            onclick: function () {
                                let query = "<Records>";
                                ctrl.data().accountingCard.map(function(elem) {
                                    let savedValue = JSON.parse(localStorage.getItem("accountingCard"));
                                    let defaultValue = (parseFloat(savedValue[elem.ID]) - Math.trunc(savedValue[elem.ID])) == 0.0 ?
                                        Math.trunc(savedValue[elem.ID]) : savedValue[elem.ID];
                                    query += "<Record ID=\""+ elem.ID +"\" Value=\""+ defaultValue +"\"/>";
                                });
                                query += "</Records>";

                                loader.show();
                                m.request({
                                    method: 'POST',
                                    url: '/api/task/' + m.route.param('taskId') + '/getPreviewAccCard',
                                    background: true,
                                    data: { xml: query }
                                }).then(function (response) {
                                    let html = response.htmlAccountingCard.replace('\r\n', '');
                                    ModalWindowContainerTotalAccCard.open(html, "ModalPreview");
                                    m.redraw.strategy("none");

                                    loader.hide();
                                });
                            },
                        }, "Просмотр"),
                    ]),
                ]),
                m(".row", [
                    m(".col-xs-8[colspan='8'][style='text-align: right']", ["Подписать и отправить карту учета"]),
                    m(".col-xs-4[colspan='4'][style='text-align: right; padding:2px 7px;'][id='']", [
                        ModalContainerTAC.init(),
                        m("button.btn.btn-info.btn-lg[style='width:100%'][id='signCard']", {
                            onclick: function () {
                                ModalContainerTAC.open("Подпись итоговой карты учета");
                                var canvas = document.getElementById("canvasSignTotalAccCard");
                                if (canvas !== null) {
                                    var signaturePad = new SignaturePad(canvas, {
                                        backgroundColor: 'rgb(255, 255, 255)'
                                    });
                                }
                                document.getElementById("yesBtnModalSignTotalAccCard").addEventListener("click", function () {

                                    var canvas = document.getElementById("canvasSignTotalAccCard");
                                    if(isCanvasBlank(canvas) == false) {
                                        var signBase64;
                                        if (canvas !== null) {
                                            signBase64 = canvas.toDataURL('image/png', 0.7);
                                        }
                                        let sign = "<img width=\"150\" height=\"75\" src=\"" + signBase64 + "\">"

                                        loader.show();
                                        m.request({
                                            method: 'POST',
                                            url: '/api/task/' + m.route.param('taskId') + '/createAccountingCard',
                                            background: true,
                                            data: {sign: sign}
                                        }).then(function (response) {
                                            if (response.signedAccountingCard["code"])
                                                ModalContainerWarningAccountingСards.open(response.signedAccountingCard["content"], "contentWarringAccCard");
                                            //alert(response.signedAccountingCard["content"]);
                                            //let html = response.signedAccountingCard.replace('\r\n', '');
                                            //ModalWindowContainerTotalAccCard.open(html, "ModalPreview");
                                            m.redraw.strategy("none");

                                            loader.hide();
                                        });
                                    }

                                    ModalContainerTAC.close();
                                });

                                m.redraw.strategy("none");
                            }
                        }, "Подписать")

                    ]),
                ])
            ]),
            ModalWindowContainerTotalAccCard.init("ModalPreview"),
            ModalContainerWarningAccountingСards.init("ModalWarringAcc"),

        ];
    }
};
